import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EndpointOptions, EndpointService } from '../endpoint.service';
import { BaseDao } from '../dao.module';

@Injectable()
export class ShipmentsGlsDaoService extends BaseDao<any> {

  constructor(endpoint: EndpointService) {
    super(endpoint);
    this.configure('/gls/', true);
  }

  getList(action: string, key: string): Observable<any[]> {

    let url = '/s/gls?action=' + action

    if (action == "trackshipment") {
      url += "&shipment=" + key;
    } else {
      url += "&pickup=" + key;
    }

    return this.handle(this.endpoint.getMany(url, this.getOptions()));
  }

  protected getOptions(): EndpointOptions {
    return {
      secure: true,
      mapper: list => list,
      resource: false,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/dao-service/shipments-gls-dao.service.ts